import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuxiliarService } from '@app/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@app/neoShared/services/utilidades/utilidades-crud.service';
import { Observable, catchError, of, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProyectoTipoService  extends UtilidadesCrudService{

  constructor(http: HttpClient, auxiliar: AuxiliarService) {
    super(
      http,
      auxiliar,
      'proyectoTipo',
      'proyectoTipo',
      'Proyecto Tipo',
      'Proyectos Tipos',
      [
        'id',
        'nombre'
      ]
    );
  }

}


